;(function() {

    document.addEventListener('DOMContentLoaded', function () {
    	cookieconsent.run({"notice_banner_type":"simple","consent_type":"express","palette":"light","change_preferences_selector":"#changePreferences","language":"da","website_name":"VUCLYNGBY.DK","cookies_policy_url":"https://vuclyngby.dk/cookies"});
	});

    var youtube = document.querySelectorAll( '.youtube' );

    for (var i = 0; i < youtube.length; i++) {

        var source = 'https://img.youtube.com/vi/'+ youtube[i].dataset.embed +'/sddefault.jpg';

        var image = new Image();
        image.src = source;
        image.addEventListener( 'load', function() {
            youtube[ i ].appendChild( image );
        }( i ) );

        youtube[i].addEventListener( 'click', function() {

            var iframe = document.createElement( 'iframe' );

            iframe.setAttribute( 'frameborder', '0' );
            iframe.setAttribute( 'allowfullscreen', '' );
            iframe.setAttribute( 'src', 'https://www.youtube.com/embed/'+ this.dataset.embed +'?rel=0&showinfo=0&autoplay=1' );

            this.innerHTML = '';
            this.appendChild( iframe );
        } );
    }

    
	jQuery(document).ready(function($) {

        $('#dataTable').DataTable( {
            "order": [[ 2, "desc" ]],
            paging: false,
            info: false,
            language: {
                "search": "Søg:",
                "sZeroRecords": "Ingen resultater"
            },
            fixedHeader: true
        } );

        // Hamburger animation
		$('.js-hamburger-toggle').on('click', function() {
			$('.js-hamburger-toggle').toggleClass('is-active');

			$('body, html').toggleClass('js-nav-open');
			return false;
		});

        // Overlay
		var bh = $('body, html');
		$('.content-overlay').on('click', function() {
			bh.hasClass('js-nav-open') && (bh.removeClass('js-nav-open'), $('.js-hamburger-toggle').removeClass('is-active'), $('.js-hamburger-toggle p').text() == 'Menu') ? $('.js-hamburger-toggle p').text('Luk') : $('.js-hamburger-toggle p').text('Menu');
		});

        // Mobile Subnavigation
		$('.navigation--mobile .menu-item-has-children').prepend('<span class="icon"></span>');
		$('.navigation--primary .menu-item-has-children').prepend('<span class="icon"></span>');
		$('.navigation .menu-item-has-children .icon').click(function() {
			var submenu = $(this).siblings('.sub-menu');
			submenu.toggleClass('js-active');
		});

    });
}());

